import { render, staticRenderFns } from "./prompt-info.vue?vue&type=template&id=196ed150&scoped=true&"
import script from "./prompt-info.vue?vue&type=script&lang=js&"
export * from "./prompt-info.vue?vue&type=script&lang=js&"
import style0 from "./prompt-info.vue?vue&type=style&index=0&id=196ed150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ed150",
  null
  
)

export default component.exports